import { useCallback, useRef } from 'react';
export function useComponentSubscriptions() {
    const subscriptionsRef = useRef([]);
    const subscribe = useCallback((componentOrType, callback) => {
        subscriptionsRef.current.push(typeof componentOrType === 'string'
            ? { type: componentOrType, callback }
            : { componentId: componentOrType.id, callback });
    }, []);
    const unsubscribe = useCallback((componentOrType, callback) => {
        const index = subscriptionsRef.current.findIndex(c => ((typeof componentOrType === 'string' &&
            c.type === componentOrType) ||
            (typeof componentOrType !== 'string' &&
                c.componentId === componentOrType.id)) &&
            c.callback === callback);
        if (index > -1) {
            subscriptionsRef.current.splice(index, 1);
        }
    }, []);
    /**
     * Called when editor notifies iframe of component changes
     */
    const notifyComponentUpdate = useCallback((component) => {
        // notify component to rerender
        subscriptionsRef.current.forEach(subscription => {
            if (subscription.componentId === component.id ||
                subscription.type === component.type) {
                // make a copy of the component to force component rerender
                const componentCopy = Object.assign({}, component);
                // console.log('notifyComponentUpdate', componentCopy);
                subscription.callback(componentCopy);
            }
        });
    }, []);
    return {
        subscribe,
        unsubscribe,
        notifyComponentUpdate
    };
}
//# sourceMappingURL=useComponentSubscriptions.js.map